import { AgGridReact } from 'ag-grid-react'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { Card, CardBody, CardHeader } from 'reactstrap'
import {
  getScheduledInterviews,
  setFormSubmitted,
} from 'store/Recruitment/actions'
import CreateInterviewModal from './CreateInterviewModal'
import WatchInterviewComponent from './WatchInterviewComponent'

function Interview() {
  const dispatch = useDispatch()
  const location = useLocation()

  const { interviews } = useSelector((store) => store.recruitment)

  const [showModal, setShowModal] = useState(false)
  const [watchInterview, setWatchInterview] = useState(false)
  const [interviewData, setInterviewData] = useState(null)

  const defaultColDef = {
    sortable: true,
    unSortIcon: false,
    suppressMenu: true,
    flex: 1,
    minWidth: 100,
    resizable: true,
  }

  const columns = [
    {
      headerName: '#',
      field: 'no',
      valueGetter: (params) => params.node.rowIndex + 1,
    },
    {
      headerName: 'Assigned Employee',
      field: 'employee',
      sortable: true,
      unSortIcon: true,
      cellRenderer: (params) => {
        return params.data.with_ai ? 'AI-Conducted Interview' : params.value
      },
    },
    {
      headerName: 'Interview Date',
      field: 'date',
      sortable: true,
      unSortIcon: true,
      cellRenderer: (params) =>
        params.value ? moment(params.value).format('DD-MM-YYYY') : '',
    },
    {
      headerName: 'Interview Time',
      field: 'time',
      sortable: true,
      unSortIcon: true,
    },
    {
      headerName: '',
      field: 'interview_link',
      cellRenderer: (params) =>
        params.value ? (
          <button
            onClick={() => {
              setWatchInterview(true)
              setInterviewData({
                id: params.data.id,
                link: params.value,
                timestamps: params.data.timestamps,
              })
            }}
            className='btn btn-info mb-1'
          >
            Watch Interview
          </button>
        ) : null,
    },
  ]

  useEffect(() => {
    dispatch(getScheduledInterviews(location?.search?.split('=')?.at(1)))
  }, [dispatch, location?.search])

  useEffect(() => {
    if (!showModal) {
      dispatch(setFormSubmitted(false))
    }
  }, [dispatch, showModal])

  if (watchInterview && interviewData) {
    return (
      <WatchInterviewComponent
        interviewData={interviewData}
        onClose={() => {
          setWatchInterview(false)
          setInterviewData(null)
        }}
      />
    )
  }

  return (
    <>
      <Card>
        <CardHeader className='title d-flex align-items-center justify-content-between'>
          Interview details{' '}
          <button className='btn btn-info' onClick={() => setShowModal(true)}>
            + Create Interview Schedule
          </button>
        </CardHeader>
        <CardBody>
          <div
            className='ag-theme-alpine'
            style={{ height: '600px', width: '100%' }}
          >
            <AgGridReact
              columnDefs={columns}
              rowData={interviews}
              defaultColDef={defaultColDef}
            />
          </div>
        </CardBody>
      </Card>
      {showModal && (
        <CreateInterviewModal
          showModal={showModal}
          setShowModal={setShowModal}
        />
      )}
    </>
  )
}

export default Interview
